import { Button } from "antd";
import { Img, Text } from "components";
import { PrimaryButton } from "components/SuperAdminAndBusiness/PrimaryButton";
import { AuthContext } from "contexts/AuthContext";
import { ClipboardCheck, Plus } from "lucide-react";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const { layoutData } = useContext(AuthContext);
  const navigate = useNavigate();
  const { t }: { t: (key: string) => string } = useTranslation();

  return (
    <>
      <div className="bg-white-A700 flex md:flex-row flex-col-reverse   w-screen max-w-full">
        <div className="flex flex-col h-screen w-full justify-center items-center px-5">
          <div className="flex flex-col items-center gap-6">
            <img
              className="w-[200px] object-contain "
              src={
                layoutData
                  ? layoutData.logo
                  : "/images/img_logo_blue_gray_800.svg"
              }
              alt={t("logoAlt")}
            />
            <div className="flex flex-col items-center justify-center w-full gap-2">
              <Text className="text-[32px] font-medium text-blue_gray-900 tracking-[-0.80px] text-center">
                404 - {t("pageNotFound")}
              </Text>
              <Text
                className="mt-[3px] text-blue_gray-400 text-center text-sm tracking-[0.28px]"
                size="txtNunitoRegular14"
              >
                {t("whatDoYouWantToDo")}
              </Text>
            </div>
          </div>

          <div className="flex flex-col gap-5 mt-5 items-center justify-start w-full md:w-[400px]">
            <PrimaryButton
              onClick={() => navigate("/whistleblower/createcomplaint")}
              size="large"
              className="w-full"
            >
              <Plus />
              {t("reportAConcern")}
            </PrimaryButton>

            <Button
              type="default"
              onClick={() => navigate("/whistleblower/anonymouscomplaint")}
              size="large"
              className="w-full"
            >
              <ClipboardCheck />
              {t("checkOnReportedConcern")}
            </Button>
          </div>

          <div className="absolute bottom-5">
            <Text
              className="text-[15px] text-blue_gray-800"
              size="txtNunitoMedium15"
            >
              {t("goTo")}
              <a
                href="/"
                className="text-[15px] font-bold text-blue_gray-800 border-b border-transparent duration-200 hover:border-blue_gray-800"
              >
                {" "}
                {t("login")}{" "}
              </a>
              {t("orCheckOn")}
              <a
                href="/whistleblower/anonymouscomplaint"
                className="text-[15px] text-blue_gray-800 border-b border-transparent duration-200 hover:border-blue_gray-800 font-bold"
              >
                {" "}
                {t("reportedConcern")}
              </a>
            </Text>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
